<!-- <app-loader *ngIf="showSpinner"> </app-loader> -->
<main class="content-wrapper" [ngClass]="{ 'dark-backround-main': selectedMode === 'dark' }">
  <div class="apply-form-main bg-light" [ngClass]="{ 'dark-backround-main': selectedMode === 'dark' }">
    <!-- form start munib  -->
    <form id="form-link-outside-btn" name="empForm" #f="ngForm" (ngSubmit)="onSubmit(f)">
      <!--Start 1st Section Personal Information  -->
      <div class="create-form pt-2 pl-4 pr-4 border" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
        <div class="mb-4" [ngClass]="{ 'dark-text': selectedMode === 'dark' }">
          <h5>Attendance Correction Request</h5>
        </div>

        <div class="row">
          <div class="col-md-12 p-0">
            <div class="col-md-12 m-0 flex-wrap">
              <!-- Row Start -->
              <div
                class="col-12 hidden-radio-btn pl-2 d-flex mb-2 justify-content-between"
                >
                <div class="p-0" [ngClass]="{ 'dark-text': selectedMode === 'dark' }">
                  <input
                    type="radio"
                    [(ngModel)]="selectedRadio"
                    [value]="'checkin'"
                    name="correction"

                    />
                    <!-- {{ sharedData.attendance_id //attendance id }} -->
                    <!-- {{ sharedData.user_id //user id }} -->

                    <label class="pl-1 pb-0">Check In</label>
                  </div>
                  <div class="p-0" [ngClass]="{ 'dark-text': selectedMode === 'dark' }">
                    <input
                      type="radio"
                      [(ngModel)]="selectedRadio"
                      [value]="'checkout'"
                      name="correction"
                      />
                      <label class="pl-1 pb-0">Check Out</label>
                    </div>
                    <div class="p-0" [ngClass]="{ 'dark-text': selectedMode === 'dark' }">
                      <input
                        type="radio"
                        [(ngModel)]="selectedRadio"
                        [value]="'overtime'"
                        name="correction"

                        />
                        <label class="pl-1 pb-0 mb-0">Over Time</label>
                      </div>
                    </div>
                    <!--  end row -->
                  </div>
                </div>

                @if (selectedRadio === 'checkin') {
                  <div class="col-md-6">
                    <div class="form-group">
                      <input
                        type="text"
                        placeholder="Check In"
                        onfocus="(this.type='time')"
                        onblur="(this.type= this.value ? 'time' : 'text')"
                        name="checkin"
                        id="checkin"
                        [(ngModel)]="_check_in"
                        ngModel
                        #checkin="ngModel"
                        class="form-control date-type pl-4"
                        required
                        />
                        @if (checkin.invalid && (checkin.touched || checkin.dirty)) {
                          <div
                            class="warning"
                            >
                            Check in required.
                          </div>
                        }
                      </div>
                    </div>
                  }

                  @if (selectedRadio === 'checkout') {
                    <div class="col-md-6">
                      <div class="form-group">
                        <input
                          type="text"
                          placeholder="Check Out"
                          onfocus="(this.type='time')"
                          onblur="(this.type= this.value ? 'time' : 'text')"
                          name="checkout"
                          id="checkout"
                          [(ngModel)]="_check_out"
                          ngModel
                          #checkout="ngModel"
                          class="form-control date-type pl-4"
                          required
                          />
                          @if (checkout.invalid && (checkout.touched || checkout.dirty)) {
                            <div
                              class="warning"
                              >
                              Check out required.
                            </div>
                          }
                        </div>
                      </div>
                    }

                    @if (selectedRadio === 'overtime') {
                      <div class="col-md-6">
                        <div class="form-group">
                          <input
                            type="number"
                            name="overtime"
                            id="overtime"
                            [(ngModel)]="_overtime"
                            placeholder="Over time Hours"
                            class="form-control no-spin-arrows pl-4"
                            ngModel
                            #overtime="ngModel"
                            [required]="selectedRadio === 'overtime'"
                            />
                            @if (overtime.invalid && (overtime.touched || overtime.dirty)) {
                              <div
                                class="warning"
                                >
                                Over Time Hour required (only in numbers)
                              </div>
                            }
                          </div>
                        </div>
                      }

                      <div class="col-12 col-md-12">
                        <div class="form-group textareaCreateuser">
                          <textarea
                            class="form-control pl-4"
                            id="reason"
                            rows="6"
                            name="reason"
                            ngModel
                            #reason="ngModel"
                            placeholder="Reason*"
                            required
                            [(ngModel)]="_reason"
                            (input)="trimText()"
                          ></textarea>
                          @if (reason.valid && (reason.dirty || reason.touched)) {
                            <div>
                              @if (_reason.trim().length < 100 ) {
                                <p class="alert alert-warning mt-2" >
                                  Ensure that the entered <strong>Reason</strong> contains minimum of 100 characters.
                                </p>
                              }
                            </div>
                          }

                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- above -->

                  <!--End 1st Section Personal Information -->
                </form>
                <!--form munib end -->
              </div>
            </main>

            <!-- button footers start -->
            <div class="footer-button" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
              <div class="btn-float-right">
                <button  (click)="back()" class="btn btn-light">Cancel</button>
                <button
                  type="submit"
                  class="btn btn-primary btnPointer ml-2"
                  form="form-link-outside-btn"
                  [disabled]="f.invalid || _reason.trim().length < 100 " >
                  Submit
                </button>
              </div>
            </div>
            <!-- button footers end -->
